module.exports = __webpack_public_path__ + "static/media/10.84d3997b.png";